const GROUP_MEMBER_ROLE = {
  OWNER: 'OWNER',
  MEMBER: 'MEMBER'
}

const GROUP_MEMBER_PERMISSIONS = {
  BILLING: 'BILLING',
  BOOKING: 'BOOKING'
}

const GROUP_MEMBER_PERMISSION_DESCRIPTIONS = {
  [GROUP_MEMBER_PERMISSIONS.BOOKING]: {
    name: GROUP_MEMBER_PERMISSIONS.BOOKING,
    title: 'Ability to take any appointment action',
    description: 'To be able to cancel, update and confirm bookings.'
  },
  [GROUP_MEMBER_PERMISSIONS.BILLING]: {
    name: GROUP_MEMBER_PERMISSIONS.BILLING,
    title: 'Ability to view Billing Portal',
    description: 'To be able to view payment options.'
  }
}

export default {
  GROUP_MEMBER_ROLE,
  GROUP_MEMBER_PERMISSIONS,
  GROUP_MEMBER_PERMISSION_DESCRIPTIONS
}
